import { CompaniesSearchService_companySearchServicePostSearch } from '@festina/legalentity-general-types/legalentity/hooks/CompaniesSearchService_companySearchServicePostSearch'

export const useCompanyAdvancedSearch =
  CompaniesSearchService_companySearchServicePostSearch.useLazyQuery
